import { ApiRoute } from "PFCore/utilities/routes";

export const bookRole = (shortlist_id) =>
  $.ajax({
    url: ApiRoute(`/api/shortlists/${shortlist_id}/book`),
    method: "PUT",
    api_version: 2
  });

// TODO: check with API
export const confirmRole = (shortlist_id) =>
  $.ajax({
    url: ApiRoute(`/api/shortlists/${shortlist_id}/confirm`),
    method: "PUT",
    api_version: 2
  });

export const fillAndBookRole = (shortlist_id, approver_id, request_reason) =>
  $.ajax({
    url: ApiRoute(`/api/shortlists/${shortlist_id}/fill_and_book`),
    method: "PUT",
    api_version: 2,
    data: {
      approver_id,
      request_reason
    }
  });

export const fill = (shortlist_id, approver_id, request_reason) =>
  $.ajax({
    url: ApiRoute(`/api/shortlists/${shortlist_id}/fill`),
    method: "PUT",
    api_version: 2,
    data: {
      approver_id,
      request_reason
    }
  });

export const getAuditRoles = ({ page, perPage, filters }) =>
  $.ajax({
    url: ApiRoute("/api/audit_roles"),
    api_version: 2,
    data: {
      filters,
      per_page: perPage || 100,
      page: page || 1
    }
  });

export const approveRequest = (shortlist_id, approver_id, reason) =>
  $.ajax({
    url: ApiRoute(`/api/exception_requests/approve`),
    method: "PUT",
    api_version: 2,
    data: { shortlist_id, approver_id, reason }
  });

export const rejectRequest = (shortlist_id, approver_id, reason) =>
  $.ajax({
    url: ApiRoute("/api/exception_requests/reject"),
    method: "PUT",
    api_version: 2,
    data: { shortlist_id, approver_id, reason }
  });

export const editRequest = (shortlist_id, approver_id) =>
  $.ajax({
    url: ApiRoute(`/api/exception_requests`),
    method: "PUT",
    api_version: 2,
    data: { approver_id, shortlist_id }
  });

export const getExceptionRequests = (activity_id, profile_ids) =>
  $.ajax({
    url: ApiRoute("/api/exception_requests"),
    api_version: 2,
    data: {
      activity_id,
      profile_ids
    }
  });

export const checkExceptions = (shortlist_id) =>
  $.ajax({
    url: ApiRoute(`/api/shortlists/${shortlist_id}/check_exceptions`),
    api_version: 2
  });
